<script lang="ts" setup>
import { PublicSellerCareQuery } from '@gql/PublicSellerCareQuery'

const t2 = useT2({
  'Washing symbols': 'Skalbimo simboliai',
  'Product care': 'Prekių priežiūra',
})
const { seller, sellerId } = useSeller('server')

const { ui: icons } = useApolloWrap2<gen.PublicSellerCareQuery, gen.PublicSellerCareQueryVariables>(PublicSellerCareQuery)({
  vars() {
    const id = sellerId.value
    return id ? { sellerId: id } : undefined
  },
  ui: (i) => helpers.arr(i?.publicSellerCareIcons),
})
// <!-- <DevLink to="https://www.intimissimi.com/lt/product-guide-textiles.html"></DevLink>
//   <DevLink to="https://www.intimissimi.com/lt/product-guide-care.html"></DevLink>
//   <DevLink to="https://www.meandem.com/fabric-lab"></DevLink> -->

useHead({
  title: t2('Product care'),
})
</script>

<template>
  <AppMenu :title="t2('Product care')">
    <template #content>
      <DocumentUi :document-id="seller?.doc?.care?._id" />
    </template>
    <h2 class="_pl1 _pb3">{{ t2('Washing symbols') }}</h2>
    <InfoCare :icons class="_mr04 _ml04" />
  </AppMenu>
</template>
